<template>
    <ul>
        <li v-for="(value, key) in data" :key="key">
            <span>{{ key }}:</span>
            <template v-if="Array.isArray(value)">
                <template v-if="isPrimitiveArray(value)">
                    {{ value.join(', ') }}
                </template>
                <template v-else>
                    <ul>
                        <li v-for="(item, index) in value" :key="index">
                            <NestedObjectDisplay :data="item" />
                        </li>
                    </ul>
                </template>
            </template>
            <template v-else-if="typeof value === 'object'">
                <NestedObjectDisplay :data="value" />
            </template>
            <template v-else>
                {{ value }}
            </template>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'NestedObjectDisplay',
    props: {
        data: {
            type: [Object, Array],
            required: true,
        },
    },
    methods: {
        isPrimitiveArray(arr) {
            return arr.every((item) => typeof item !== 'object')
        },
    },
}
</script>
